// Patient-disclosure mode of the AI Assistant: what patient data the AI vendor receives.
export const DISCLOSURE_MODES = ["DEIDENTIFIED", "IDENTIFIED"];

// Body of PUT /api/mcpSetting/{clinicUrl}/patientDisclosure. IDENTIFIED must carry
// an explicit acknowledgement (the BE rejects it otherwise); DEIDENTIFIED never does.
export const disclosurePayload = (mode, acknowledged) => {
  if (mode === "DEIDENTIFIED") return { mode };
  if (mode === "IDENTIFIED") {
    if (acknowledged !== true) throw new Error("IDENTIFIED mode requires acknowledged: true");
    return { mode, acknowledged: true };
  }
  throw new Error(`Unknown patient disclosure mode: ${mode}`);
};
